/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "events",
            "endpoint": "https://gzou64dpva.execute-api.us-east-1.amazonaws.com/mainb",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:76761868-1fac-4fc0-8f11-388aede70e6c",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_HJrjQdvMc",
    "aws_user_pools_web_client_id": "7ib1qdm29j7k4amlutukotqvra",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "Events7-mainb",
            "region": "us-east-1"
        },
        {
            "tableName": "Guests7-mainb",
            "region": "us-east-1"
        },
        {
            "tableName": "Invitations7-mainb",
            "region": "us-east-1"
        },
        {
            "tableName": "Logs7-mainb",
            "region": "us-east-1"
        },
        {
            "tableName": "Notification7-mainb",
            "region": "us-east-1"
        },
        {
            "tableName": "Profile7-mainb",
            "region": "us-east-1"
        },
        {
            "tableName": "RSVP7-mainb",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "mediabucket67687932198543215478543257c5d-mainb",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
